import { useEffect } from "react";
import faixa from "../assets/certificado/cert-stripe.png";
import assinatura from "../assets/certificado/assinatura-gabriel-nova.png";
import selos from "../assets/certificado/selos-certificado-shadow.png";
import { dataDoDia } from "./FaculdadeUi";

// O certificado do curso que mora no hub (000375): o MESMO papel que a Lovable dava ao aluno do
// Fundamentos da Reforma Tributária — a faixa navy com o dourado, o texto da mantenedora da FBC, as
// "20 horas", a assinatura do Diretor Geral e os selos —, por decisão do Enzo em 30/10. Os três
// PNGs vieram do repositório de origem, sem mudança.
//
// Cor FIXA de propósito: é papel, e papel não troca com o tema de quem o abre (a regra do
// `documentosMei.ts` e da folha do currículo).
//
// As medidas estão em unidades do CONTÊINER (`cqw`), e não em px com `clamp` como na origem: o
// tamanho do texto acompanha a largura do papel na tela E na impressão, sem dois conjuntos de
// medidas. Cada número é o da origem dividido pelos 700px do papel dela (30px → 4,29cqw).
//
// A impressão é a do navegador (`window.print()`), como o currículo: o texto sai vetorial e o
// nome do aluno, selecionável. A folha é A4 DEITADA e sem margem, para a faixa ir até a borda — a
// regra `@page` vale só enquanto esta peça está na tela, porque a global é a do currículo (A4 em
// pé, 12mm).

const PAPEL = "#E8E4E0";
const TINTA = "#1a1a1a";
const TEXTO = "#444";

/**
 * `data` é o dia em que o certificado é aberto (AAAA-MM-DD, o de hoje em São Paulo, dito pelo
 * banco), como na Lovable (000378). Ela é LIDA por `dataDoDia`, nunca convertida por `Date`: em
 * São Paulo, a meia-noite UTC de uma data sem hora é o dia anterior.
 */
export default function CertificadoDoCurso({
  nome,
  curso,
  data,
}: {
  nome: string;
  curso: string;
  data: string;
}) {
  useEffect(() => {
    const estilo = document.createElement("style");
    estilo.setAttribute("data-certificado-impressao", "");
    estilo.textContent = `@media print {
  @page { size: A4 landscape; margin: 0; }
  /* O resto da tela fica invisível, mas OCUPA lugar: sem isto, a altura dela vira uma segunda
     folha em branco. */
  html, body { height: 210mm !important; overflow: hidden !important; }
  .certificado-papel {
    width: 297mm !important; height: 210mm !important; max-width: none !important;
    border-radius: 0 !important; box-shadow: none !important;
    -webkit-print-color-adjust: exact; print-color-adjust: exact;
  }
}`;
    document.head.appendChild(estilo);
    return () => estilo.remove();
  }, []);

  const c = (n: number) => `${n}cqw`;

  return (
    <div
      data-certificado
      className="certificado-papel area-de-impressao relative w-full max-w-[760px] overflow-hidden rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
      style={{ aspectRatio: "297 / 210", backgroundColor: PAPEL, containerType: "inline-size" }}
    >
      <img src={faixa} alt="" className="pointer-events-none absolute inset-0 size-full" />

      <div className="absolute inset-0 flex flex-col justify-between" style={{ padding: "7% 28% 7% 8%" }}>
        <div>
          <h2
            style={{ fontSize: c(4.29), fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.15, color: TINTA, marginBottom: c(2.86) }}
          >
            CERTIFICADO DE
            <br />
            CONCLUSÃO DE CURSO
          </h2>
          <p style={{ fontSize: c(2), lineHeight: 1.6, color: TEXTO, marginBottom: c(2.29) }}>
            <strong>Contabilidade Facilitada Educacional Ltda,</strong> mantenedora da Faculdade Brasileira de
            Contabilidade, certifica que
          </p>
          <div style={{ display: "inline-block", maxWidth: "100%", marginBottom: c(2.29) }}>
            <p
              data-certificado-nome
              style={{ fontSize: c(3.43), fontWeight: 500, color: TINTA, lineHeight: 1.3, margin: 0, wordBreak: "break-word" }}
            >
              {nome}
            </p>
            <div style={{ height: 1, backgroundColor: "#bbb", marginTop: c(0.86) }} />
          </div>
          <p style={{ fontSize: c(2), lineHeight: 1.6, color: TEXTO }}>
            completou com êxito o curso de <strong data-certificado-curso>{curso},</strong> com 20 horas de duração.
          </p>
        </div>

        <div style={{ display: "flex", gap: c(6.86), alignItems: "flex-end" }}>
          <div>
            <p data-certificado-data style={{ fontSize: c(2.29), fontWeight: 700, color: TINTA, lineHeight: 1.3, margin: 0 }}>
              {dataDoDia(data)}
            </p>
            <div style={{ width: c(14.29), height: 1, backgroundColor: "#aaa", marginTop: c(0.86) }} />
            <p style={{ fontSize: c(1.57), color: "#666", marginTop: c(0.57) }}>Data de Conclusão</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img
              src={assinatura}
              alt="Assinatura de Gabriel Rabelo da Silva"
              style={{ width: c(22.86), height: "auto", objectFit: "contain", marginBottom: c(-0.57) }}
            />
            <div style={{ width: c(25.14), height: 1, backgroundColor: "#999" }} />
            <p style={{ fontSize: c(1.57), fontWeight: 700, color: "#333", marginTop: c(0.57) }}>Gabriel Rabelo da Silva</p>
            <p style={{ fontSize: c(1.43), color: "#555" }}>Diretor Geral</p>
          </div>
        </div>
      </div>

      <img
        src={selos}
        alt="Selos da Faculdade Brasileira de Contabilidade"
        className="absolute z-20"
        style={{ bottom: "6%", right: "2%", width: c(15), height: "auto" }}
      />
    </div>
  );
}
